export interface SponsoredOfferPlacement extends App.SponsoredOfferListItem {
  rawOffset: number
}

function computeSponsoredOfferPlacements(sponsoredOffers: Array<App.SponsoredOfferListItem>, offerIds: Array<string>): Array<SponsoredOfferPlacement> {
  const promoted = [...sponsoredOffers]
    .sort((a, b) => a.position - b.position)
    .filter(offer => {
      const organicIndex = offerIds.indexOf(offer.offerId)
      return organicIndex === -1 || organicIndex >= offer.position - 1
    })

  return promoted
    .map((offer, index) => ({
      ...offer,
      rawOffset: offer.position - 1 - index,
    }))
    .filter(placement => placement.rawOffset >= 0)
}

export default computeSponsoredOfferPlacements
